<div class="container-fluid">
  <div class="card-group vh-90">
    <!-- Left Side - Track Configuration -->
    <si-card class="h-100" data-tour-id="tour-track" [heading]="'TRACK.TRACK' | translate">
      <div class="card-body d-flex flex-column h-100 p-0" body>
        <app-track class="h-100 p-6 pt-3" />
      </div>
    </si-card>

    <!-- Right Side - Schedule Configuration -->
    <si-card class="h-100" data-tour-id="tour-schedule" [heading]="'SCHEDULE.SCHEDULE' | translate">
      <div class="card-body d-flex flex-column h-100 p-0" body>
        <app-schedule class="h-100 p-6 pt-3" />
      </div>
    </si-card>
  </div>
</div>
